// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-panel .panel-infos, .compt .pp-info .ppi-part {
  word-break: break-all;
  word-break: break-word;
}

.ion-activatable {
  position: relative;
}
.ion-activatable.ripple-bounded {
  overflow: hidden;
}
.ion-activatable > ion-ripple-effect.ripple {
  /*&.main-soft {
    color: var(--app-main-soft);
  }*/
}
.ion-activatable > ion-ripple-effect.ripple.contr {
  color: var(--app-contr);
}
.ion-activatable > ion-ripple-effect.ripple.darkest {
  color: var(--app-darkest);
}
.ion-activatable > ion-ripple-effect.ripple.lightest {
  color: var(--app-lightest);
}
.ion-activatable > ion-ripple-effect.ripple.main {
  color: var(--app-main);
}
.ion-activatable > ion-ripple-effect.ripple.main-darker {
  color: var(--app-main-darker);
}
.ion-activatable > ion-ripple-effect.ripple.main-softer {
  color: var(--app-main-softer);
}
.ion-activatable > ion-ripple-effect.ripple.main-strong {
  color: var(--app-main-strong);
}
.ion-activatable > ion-ripple-effect.ripple.mid-light {
  color: var(--app-mid-light);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter {
  color: var(--app-mid-lighter);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter-2 {
  color: var(--app-mid-lighter-2);
}

.compt {
  border-radius: 5px;
  padding: 15px;
  background-color: white;
  color: black;
}
.compt .btns {
  margin-top: 20px;
  margin-right: -8px;
  margin-bottom: -7px;
  display: flex;
  flex-wrap: wrap;
}
.compt .btns .compt-btn {
  margin: 0;
  margin-right: 8px;
  margin-bottom: 7px;
  --padding-start: 21px;
  --padding-end: 15px;
  font-weight: 400;
  text-transform: none;
}
.compt .btns .compt-btn .btn-icon {
  margin-right: 12px;
  font-size: 18px;
}
.compt .btns.jcc {
  justify-content: center;
}
.compt .description {
  margin-bottom: 20px;
  font-size: 15px;
  line-height: 1.3;
}
.compt .pp-info {
  margin-bottom: 10px;
}
.compt .pp-info .ppi-part {
  display: inline;
}
.compt .pp-info .ppi-part.ppi-lbl {
  font-weight: 500;
}
.compt .pp-info .ppi-part.ppi-val {
  margin-top: 1px;
  margin-left: 2px;
}
.compt .position {
  margin-bottom: 10px;
  font-weight: 500;
}
.compt .position.mb-15 {
  margin-bottom: 15px;
}
.compt .position.mb-20 {
  margin-bottom: 20px;
}
.compt .stats {
  margin-right: -25px;
  margin-bottom: -5px;
  display: flex;
  flex-wrap: wrap;
  /* .gc-info {
    margin-right: 25px;
    margin-bottom: 5px;

    .gci-lbl {
      padding-left: 10px;
    }

    .gci-wrap-value {
      padding-top: 1px;
      padding-left: 8px;
    }

  } */
}
.compt .stats .gc-info {
  margin-right: 25px;
  margin-bottom: 5px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.compt .stats .gc-info .gci-icon {
  font-size: 22px;
}
.compt .stats .gc-info .gci-lbl {
  font-weight: 500;
}
.compt .stats .gc-info .gci-lbl.pl-10 {
  padding-left: 10px;
}
.compt .stats .gc-info .gci-wrap-value {
  padding-top: 1px;
  padding-left: 8px;
  display: inline-flex;
  align-items: flex-end;
}
.compt .stats .gc-info .gci-wrap-value .gci-unit {
  padding-left: 5px;
  font-size: 14px;
}
.compt .stats.jcc {
  justify-content: center;
}
.compt .stats.pt-5 {
  padding-top: 5px;
}
.compt.w-300 {
  width: 300px;
}
.compt.w-460 {
  /* min- */
  width: 460px;
}

.compt-btn {
  min-width: 133px;
}

.diagnostic-row {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  gap: 3px;
  margin-bottom: 4px;
}

.anomalia {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid #f5c6cb;
  border-radius: 0.25rem;
  color: #721c24;
  background-color: #f8d7da;
}

.app-item {
  margin-top: -10px;
  margin-left: -15px;
  margin-bottom: 6px;
}

.info-link {
  cursor: pointer;
  font-size: 10px;
  margin-bottom: 6px;
  margin-left: 16px;
}

.close-button {
  position: absolute;
  right: 10px;
}

.new-lbl {
  margin-top: 1px;
  color: var(--app-cover);
  font-size: 10px;
}
.new-lbl .new-lbl-icon {
  margin-right: 2px;
  font-size: 9px;
}

.ottieni-indirizzo {
  cursor: pointer;
  font-weight: 500;
}

.alert-panel {
  border-radius: 5px;
  border-width: 1px;
  border-style: solid;
  padding: 7px 10px;
  display: flex;
  align-items: center;
  margin: 10px 0;
  cursor: pointer;
}
.alert-panel .panel-icon {
  margin-right: 15px;
  font-size: 24px;
}
.alert-panel .panel-icon--info {
  font-size: 15px;
  margin-right: 0;
  color: var(--app-mid-light) !important;
}
.alert-panel .panel-infos {
  flex: 1;
}
.alert-panel .panel-infos .pi-row--lbl {
  font-weight: 500;
}
.alert-panel .panel-infos .pi-row--desc {
  color: var(--app-mid-light);
  font-size: 12px;
}
.alert-panel .panel-infos .pi-row--action {
  cursor: pointer;
  font-size: 12px;
}
.alert-panel .panel-infos .pi-row:not(:last-child) {
  margin-bottom: 5px;
}
.alert-panel--success {
  border-color: var(--app-succ);
}
.alert-panel--success .panel-icon {
  color: var(--app-succ);
}
.alert-panel--success .pi-row--lbl {
  color: var(--app-succ);
}
.alert-panel--warn {
  border-color: var(--app-warn);
}
.alert-panel--warn .panel-icon {
  color: var(--app-warn);
}
.alert-panel--warn .pi-row--lbl {
  color: var(--app-warn);
}
.alert-panel--error {
  border-color: var(--app-danger);
}
.alert-panel--error .panel-icon {
  color: var(--app-danger);
}
.alert-panel--error .pi-row--lbl {
  color: var(--app-danger);
}
.alert-panel--loading {
  border-color: var(--app-mid-light);
}
.alert-panel--loading .panel-icon {
  color: var(--app-mid-light);
}
.alert-panel--loading .pi-row--lbl {
  color: var(--app-mid-light);
}

.d-row {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;
}
.d-row .ml {
  margin-left: 5px;
  margin-top: 4px;
}
.d-row .pointer {
  cursor: pointer;
}
.d-row ion-icon {
  font-size: 9px;
}
.d-row ion-icon.icon-big {
  font-size: 17px;
}
.d-column {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}
.d-column .ml {
  margin-left: 5px;
  margin-top: 4px;
}
.d-column .pointer {
  cursor: pointer;
}
.d-column ion-icon {
  font-size: 9px;
}
.d-column ion-icon.icon-big {
  font-size: 17px;
}`, "",{"version":3,"sources":["webpack://./src/theme/desktop/desktop.scss","webpack://./src/app/components/desktop/map-popup-car/map-popup-car.component.scss","webpack://./src/theme/desktop/map-popup.scss"],"names":[],"mappings":"AA4PA;EACE,qBAAA;EAEA,sBAAA;AC5PF;;AD4RA;EACE,kBAAA;ACzRF;AD2RE;EACE,gBAAA;ACzRJ;AD6RE;EAwBE;;IAAA;AChTJ;AD0RI;EACE,uBAAA;ACxRN;AD4RI;EACE,yBAAA;AC1RN;AD6RI;EACE,0BAAA;AC3RN;AD+RI;EACE,sBAAA;AC7RN;ADgSI;EACE,6BAAA;AC9RN;ADqSI;EACE,6BAAA;ACnSN;ADsSI;EACE,6BAAA;ACpSN;ADwSI;EACE,2BAAA;ACtSN;ADySI;EACE,6BAAA;ACvSN;AD0SI;EACE,+BAAA;ACxSN;;ACpCA;EACE,kBFPa;EEQb,aAAA;EAKA,uBAAA;EACA,YAAA;ADmCF;ACjCE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,aAAA;EACA,eAAA;ADkCJ;AChCI;EACE,SAAA;EACA,iBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,oBAAA;ADgCN;AC9BM;EACE,kBAAA;EACA,eAAA;ADgCR;AC5BI;EACE,uBAAA;AD8BN;ACzBE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AD2BJ;ACvBE;EACE,mBAAA;ADyBJ;ACvBI;EAEE,eAAA;ADwBN;ACrBM;EACE,gBAAA;ADuBR;ACnBM;EACE,eAAA;EACA,gBAAA;ADqBR;ACbE;EACE,mBAAA;EACA,gBAAA;ADeJ;ACbI;EACE,mBAAA;ADeN;ACbI;EACE,mBAAA;ADeN;ACVE;EACE,mBAAA;EACA,mBAAA;EAEA,aAAA;EACA,eAAA;EAGA;;;;;;;;;;;;;KAAA;ADsBJ;ACNI;EACE,kBAAA;EACA,kBAAA;EAEA,aAAA;EACA,eAAA;EACA,mBAAA;ADON;ACJM;EACE,eAAA;ADMR;ACFM;EACE,gBAAA;ADIR;ACFQ;EACE,kBAAA;ADIV;ACCM;EACE,gBAAA;EACA,iBAAA;EAEA,oBAAA;EACA,qBAAA;ADAR;ACIQ;EACE,iBAAA;EACA,eAAA;ADFV;ACUI;EACE,uBAAA;ADRN;ACWI;EACE,gBAAA;ADTN;ACeE;EACE,YAAA;ADbJ;ACeE;EACE,SAAA;EAAU,YAAA;ADZd;;AA9JA;EACE,gBAAA;AAiKF;;AA9JA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAiKF;;AA5JA;EACE,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;AA+JF;;AA5JA;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;AA+JF;;AAxJA;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA2JF;;AAxJA;EACE,kBAAA;EACA,WAAA;AA2JF;;AAtJA;EACE,eAAA;EAEA,uBAAA;EACA,eAAA;AAwJF;AAtJE;EACE,iBAAA;EACA,cAAA;AAwJJ;;AApJA;EACE,eAAA;EACA,gBAAA;AAuJF;;AApJA;EACE,kBDpEa;ECqEb,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAuJF;AArJE;EACE,kBAAA;EACA,eAAA;AAuJJ;AArJI;EACE,eAAA;EACA,eAAA;EACA,sCAAA;AAuJN;AAnJE;EACE,OAAA;AAqJJ;AAjJM;EACE,gBAAA;AAmJR;AAjJM;EACE,2BAAA;EACA,eAAA;AAmJR;AAhJM;EACE,eAAA;EACA,eAAA;AAkJR;AA/IM;EACE,kBAAA;AAiJR;AA3IE;EAEE,6BADQ;AA6IZ;AA1II;EACE,sBAJM;AAgJZ;AAxIM;EACE,sBATI;AAmJZ;AApIE;EAEE,6BADQ;AAsIZ;AAnII;EACE,sBAJM;AAyIZ;AAjIM;EACE,sBATI;AA4IZ;AA7HE;EAEE,+BADQ;AA+HZ;AA5HI;EACE,wBAJM;AAkIZ;AA1HM;EACE,wBATI;AAqIZ;AAtHE;EAEE,kCADQ;AAwHZ;AArHI;EACE,2BAJM;AA2HZ;AAnHM;EACE,2BATI;AA8HZ;;AA7GA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAgHF;AA9GE;EACE,gBAAA;EACA,eAAA;AAgHJ;AA7GE;EACE,eAAA;AA+GJ;AA5GE;EACE,cAAA;AA8GJ;AA7GI;EACE,eAAA;AA+GN;AAnGA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AAqGF;AAnGE;EACE,gBAAA;EACA,eAAA;AAqGJ;AAlGE;EACE,eAAA;AAoGJ;AAjGE;EACE,cAAA;AAmGJ;AAlGI;EACE,eAAA;AAoGN","sourcesContent":["\n\n$borderDivider: 1px solid var(--app-mid-lighter-2);\n$borderRadius: 5px;\n\n$btnShadow:\n  0 3px 1px -2px rgba(0, 0, 0, 0.2),\n  0 2px 2px 0 rgba(0, 0, 0, 0.14),\n  0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n$shadow: 0 8px 16px rgba(var(--app-cover-rgb), .15);\n$shadow-sm: 0 4px 8px rgba(var(--app-cover-rgb), .15);\n\n\n// page\n\n$page_minW: 1280px;\n$page_maxW: 1920px;\n\n\n// >media queries\n\n// large screens: 1080p, 2K, 4K\n$pageWild_w: $page_maxW;\n\n\n// >padding\n\n$page_pb50: 50px;\n$page_pb20: 20px;\n\n$page_pt20: 20px;\n$page_pt30: 30px;\n\n$page_px: 20px;\n$page_py20: 20px;\n\n$page_p: $page_pt20 $page_px $page_pb50;\n$page_p-v2: $page_pt30 $page_px $page_pb50;\n\n\n$popover_p: 10px 0;\n\n\n\n\n\n\n\n%btn {\n  margin: 0;\n  font-weight: 600;\n}\n\n%cardHead {\n  border-bottom: $borderDivider;\n  padding: 9px 12px;\n\n  color: var(--app-mid-dark);\n  // font-size: 17px;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n\n\n  /* .card-head-btns {\n    margin-left: auto;\n    padding-left: 20px;\n\n    display: flex;\n    align-items: center;\n  } */\n\n  .card-head-icon {\n    margin-right: 10px;\n    // font-size: 20px;\n    font-size: 18px;\n  }\n\n}\n\n%checkbox {\n  // --border-width: 1px;\n  --border-color: rgba(var(--app-mid-light-rgb), .8);\n  --size: 19px;\n\n  // pointer-events: none;\n}\n\n// aka 'quick actions'\n%mapHudBtns {\n  border-radius: $borderRadius;\n\n  $px: 10px;\n  padding: 7px $px;\n\n  background-color: var(--app-base);\n  display: flex;\n\n  box-shadow: $shadow;\n\n\n  .hqa-btn-wrap {\n\n    .hqa-btn {\n      margin: 0;\n      --border-radius: 50%;\n\n      --padding-top: 0;\n      --padding-bottom: 0;\n      --padding-start: 0;\n      --padding-end: 0;\n\n      height: auto;\n\n      font-size: 11px;\n\n      .btn-icon {\n        margin: 8px;\n      }\n    }\n\n\n    &:not(:last-child) {\n      margin-right: $px;\n      border-right: $borderDivider;\n      padding-right: $px;\n    }\n  }\n\n}\n\n%search {\n  /*\n  --background\tBackground of the searchbar\n  --cancel-button-color\tColor of the searchbar cancel button\n  --clear-button-color\tColor of the searchbar clear button\n  --color\tColor of the searchbar text\n  --icon-color\tColor of the searchbar icon\n  --placeholder-color\tColor of the searchbar placeholder\n  --placeholder-font-style\tFont style of the searchbar placeholder\n  --placeholder-font-weight\tFont weight of the searchbar placeholder\n  --placeholder-opacity\tOpacity of the searchbar placeholder\n  */\n\n  border: $borderDivider;\n  // fix: visual glitch\n  --border-radius: #{$borderRadius};\n  border-radius: $borderRadius;\n\n  padding: 0;\n\n  --box-shadow: none;\n}\n\n%statusCircle {\n  border-radius: 50%;\n\n  height: 10px;\n  width: 10px;\n\n  &.status-off {\n    background-color: var(--app-danger);\n  }\n  &.status-on {\n    background-color: var(--app-succ);\n  }\n}\n\n\n// input\n\n%input {\n  // --background\tBackground of the input\n  // --color\tColor of the input text\n  // --padding-bottom\tBottom padding of the input\n  // --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n  // --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n  // --padding-top\tTop padding of the input\n  // --placeholder-color\tColor of the input placeholder text\n  // --placeholder-font-style\tFont style of the input placeholder text\n  // --placeholder-font-weight\tFont weight of the input placeholder text\n  // --placeholder-opacity\tOpacity of the input placeholder text\n\n  border: $borderDivider;\n  border-radius: 5px;\n\n  // --padding-top: 10px;\n  // --padding-bottom: 10px;\n   --padding-start: 8px;\n  --padding-end: 8px;\n}\n\n%input-lg {\n  @extend %input;\n\n  $p: 12px;\n  --padding-top: #{$p};\n  --padding-bottom: #{$p};\n  --padding-start: #{$p};\n  --padding-end: #{$p};\n}\n\n\n// modal\n\n%modalFooter {\n  border-top: $borderDivider;\n\tpadding: 10px $page_px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t.foot-btn {\n\t\tmargin: 0;\n    font-weight: 600;\n\n    // .btn-icon {}\n\n    &.mw-120 {\n      min-width: 120px;\n    }\n\t}\n\n\t&::before {\n\t\tcontent: normal;\n\t}\n}\n\n%modalHeader {\n  padding: 15px $page_px;\n  background-color: var(--app-main-darker);\n\n  .head-elem {\n    &.he-title {\n      margin-bottom: 20px;\n\n      &.mb-0 {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &.p-20 {\n    padding: $page_py20 $page_px;\n  }\n}\n\n\n// text\n\n%longWord {\n  word-break: break-all;\n  // Edge 79, Firefox 67 - also: deprecated?\n  word-break: break-word;\n}\n\n%oneLiner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n\n\n\n\n\n\nion-header,\nion-content,\nion-footer {\n  //font-size: 15px;\n\n  // works but must be done on project setup\n  // some elems already in use need white-space: nowrap;\n  // @extend %longWord;\n}\n\n\n\n\n\n\n// effect\n\n.ion-activatable {\n  position: relative;\n\n  &.ripple-bounded {\n    overflow: hidden;\n  }\n\n\n  & > ion-ripple-effect.ripple {\n\n    &.contr {\n      color: var(--app-contr);\n    }\n\n\n    &.darkest {\n      color: var(--app-darkest);\n    }\n\n    &.lightest {\n      color: var(--app-lightest);\n    }\n\n\n    &.main {\n      color: var(--app-main);\n    }\n\n    &.main-darker {\n      color: var(--app-main-darker);\n    }\n\n    /*&.main-soft {\n      color: var(--app-main-soft);\n    }*/\n\n    &.main-softer {\n      color: var(--app-main-softer);\n    }\n\n    &.main-strong {\n      color: var(--app-main-strong);\n    }\n\n\n    &.mid-light {\n      color: var(--app-mid-light);\n    }\n\n    &.mid-lighter {\n      color: var(--app-mid-lighter);\n    }\n\n    &.mid-lighter-2 {\n      color: var(--app-mid-lighter-2);\n    }\n\n  }//& > ion-ripple-effect.ripple\n\n}//.ion-activatable\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","\n@import \"../../../../theme/desktop/map-popup\";\n\n\n.compt-btn {\n  min-width: 133px;\n}\n\n.diagnostic-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  gap: 3px;\n  margin-bottom: 4px;\n}\n\n\n\n.anomalia{\n  position: relative;\n  padding: .75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid #f5c6cb;\n  border-radius: .25rem;\n  color: #721c24;\n  background-color: #f8d7da;\n}\n\n.app-item{\n  margin-top: -10px;\n  margin-left: -15px;\n  margin-bottom: 6px;\n}\n\n.row{\n  //margin: 6px 0;\n}\n\n.info-link{\n  cursor: pointer;\n  font-size: 10px;\n  margin-bottom: 6px;\n  margin-left: 16px;\n}\n\n.close-button{\n  position: absolute;\n  right: 10px;\n}\n\n\n\n.new-lbl {\n  margin-top: 1px;\n  // color: var(--app-mid-dark);\n  color: var(--app-cover); // visually more similar...\n  font-size: 10px;\n\n  .new-lbl-icon {\n    margin-right: 2px;\n    font-size: 9px;\n  }\n}\n\n.ottieni-indirizzo{\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.alert-panel {\n  border-radius: $borderRadius;\n  border-width: 1px;\n  border-style: solid;\n  padding: 7px 10px;\n  display: flex;\n  align-items: center;\n  margin: 10px 0;\n  cursor: pointer;\n\n  .panel-icon {\n    margin-right: 15px;\n    font-size: 24px;\n\n    &--info{\n      font-size: 15px;\n      margin-right: 0;\n      color: var(--app-mid-light)!important;\n    }\n  }\n\n  .panel-infos {\n    flex: 1;\n    @extend %longWord;\n\n    .pi-row {\n      &--lbl {\n        font-weight: 500;\n      }\n      &--desc {\n        color: var(--app-mid-light);\n        font-size: 12px;\n      }\n\n      &--action{\n        cursor: pointer;\n        font-size: 12px;\n      }\n\n      &:not(:last-child) {\n        margin-bottom: 5px;\n      }\n    }\n\n  }\n\n  &--success {\n    $color: var(--app-succ);\n    border-color: $color;\n\n    .panel-icon {\n      color: $color;\n    }\n\n    .pi-row {\n      &--lbl {\n        color: $color;\n      }\n    }\n\n  }\n\n  &--warn {\n    $color: var(--app-warn);\n    border-color: $color;\n\n    .panel-icon {\n      color: $color;\n    }\n\n    .pi-row {\n      &--lbl {\n        color: $color;\n      }\n    }\n\n  }\n\n  &--error {\n    $color: var(--app-danger);\n    border-color: $color;\n\n    .panel-icon {\n      color: $color;\n    }\n\n    .pi-row {\n      &--lbl {\n        color: $color;\n      }\n    }\n\n  }\n\n  &--loading {\n    $color: var(--app-mid-light);\n    border-color: $color;\n\n    .panel-icon {\n      color: $color;\n    }\n\n    .pi-row {\n      &--lbl {\n        color: $color;\n      }\n    }\n\n  }\n}\n\n\n.d-row{\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: start;\n\n  .ml{\n    margin-left: 5px;\n    margin-top: 4px;\n  }\n  \n  .pointer{\n    cursor: pointer;\n  }\n\n  ion-icon{\n    font-size: 9px;\n    &.icon-big{\n      font-size: 17px;\n    }\n  }\n\n  &.center{\n\n  }\n\n}\n\n\n\n.d-column{\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: start;\n\n  .ml{\n    margin-left: 5px;\n    margin-top: 4px;\n  }\n\n  .pointer{\n    cursor: pointer;\n  }\n\n  ion-icon{\n    font-size: 9px;\n    &.icon-big{\n      font-size: 17px;\n    }\n  }\n\n  &.center{\n\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------\n\n\n@import \"desktop\";\n\n\n\n\n// component\n.compt {\n  border-radius: $borderRadius;\n  padding: 15px;\n\n  //background-color: rgba(var(--app-mid-dark-rgb), .75);\n  //color: var(--app-base);\n\n  background-color: white;\n  color: black;\n\n  .btns {\n    margin-top: 20px;\n    margin-right: -8px;\n    margin-bottom: -7px;\n\n    display: flex;\n    flex-wrap: wrap;\n\n    .compt-btn {\n      margin: 0;\n      margin-right: 8px;\n      margin-bottom: 7px;\n\n      --padding-start: 21px;\n      --padding-end: 15px;\n\n      font-weight: 400;\n      text-transform: none;\n\n      .btn-icon {\n        margin-right: 12px;\n        font-size: 18px;\n      }\n    }\n\n    &.jcc {\n      justify-content: center;\n    }\n  }\n\n\n  .description {\n    margin-bottom: 20px;\n    font-size: 15px;\n    line-height: 1.3;\n  }\n\n\n  .pp-info {\n    margin-bottom: 10px;\n\n    .ppi-part  {\n      @extend %longWord;\n      display: inline;\n\n\n      &.ppi-lbl {\n        font-weight: 500;\n      }\n\n\n      &.ppi-val {\n        margin-top: 1px;\n        margin-left: 2px;\n      }\n\n\n    }\n  }\n\n\n  .position {\n    margin-bottom: 10px;\n    font-weight: 500;\n\n    &.mb-15 {\n      margin-bottom: 15px;\n    }\n    &.mb-20 {\n      margin-bottom: 20px;\n    }\n  }\n\n\n  .stats {\n    margin-right: -25px;\n    margin-bottom: -5px;\n\n    display: flex;\n    flex-wrap: wrap;\n\n\n    /* .gc-info {\n      margin-right: 25px;\n      margin-bottom: 5px;\n\n      .gci-lbl {\n        padding-left: 10px;\n      }\n\n      .gci-wrap-value {\n        padding-top: 1px;\n        padding-left: 8px;\n      }\n\n    } */\n\n\n    .gc-info {\n      margin-right: 25px;\n      margin-bottom: 5px;\n\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n\n\n      .gci-icon {\n        font-size: 22px;\n      }\n\n\n      .gci-lbl {\n        font-weight: 500;\n\n        &.pl-10 {\n          padding-left: 10px;\n        }\n      }\n\n\n      .gci-wrap-value {\n        padding-top: 1px;\n        padding-left: 8px;\n\n        display: inline-flex;\n        align-items: flex-end;\n\n        // .gci-b {}\n\n        .gci-unit {\n          padding-left: 5px;\n          font-size: 14px;\n        }\n      }\n\n\n    }\n\n\n    &.jcc {\n      justify-content: center;\n    }\n\n    &.pt-5 {\n      padding-top: 5px;\n    }\n\n  }\n\n\n  &.w-300 {\n    width: 300px;\n  }\n  &.w-460 {\n    /* min- */width: 460px;\n  }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
